import styled from "styled-components"
import { ReactNode } from "react"
import devices from "styles/devices"
import React from "react"

const SectionTitle = styled.div`
  padding: 24px 32px 8px 32px;

  & > h2 {
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
  }
  & > span {
    font-weight: 600;
    font-size: 18px;
  }

  @media screen and ${devices.bp_xl} {
    padding: 24px 32px 8px 32px;
  }
`

const DetailsSectionContainer = styled.div`
  background: #fff;
  border-radius: 24px;
`

interface DetailsSectionProps {
  title?: string
  children: ReactNode
  smallTitle?: boolean
}

export const DetailsSection = ({ title, children, smallTitle }: DetailsSectionProps) => {
  return (
    <DetailsSectionContainer>
      {title && <SectionTitle>{smallTitle ? <span>{title}</span> : <h2>{title}</h2>}</SectionTitle>}
      {children}
    </DetailsSectionContainer>
  )
}
